module.exports = __webpack_public_path__ + "img/add_user.78205f1a.svg";